import moment from 'moment';
import Pikaday from 'pikaday';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['datepicker', 'container', 'outerContainer', 'image', 'label'];

  initialize() {
    this.updateLastCardListener();
  }

  updateLastCardListener() {
    document.addEventListener('eventGroupProcessed', this.handleLastEventCardProcessed);
  }

  disconnect() {
    document.removeEventListener('eventGroupProcessed', this.handleLastEventCardProcessed);
  }

  handleLastEventCardProcessed = () => {
    this.startCalendar();
  };

  startCalendar() {
    this.viewAllTargets = document.querySelectorAll('.js-viewall')
    this.gridGroups = document.querySelectorAll('.js-grid-group');
    this.eventsContainer = document.querySelector('.js-events-container');
    let calendarOptions = {
      field: this.datepickerTarget,
      minDate: new Date(),
      position: 'bottom right',
      i18n: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      },
      events: this.getEvents(),
      bound: false,
      container: this.containerTarget,
      onSelect: this.select.bind(this),
    };
    this.pika = new Pikaday(calendarOptions);
    this.viewAllTargets.forEach((viewAll) => {
      viewAll.addEventListener('click', this.clear.bind(this))
    })
  }

  openMobile() {
    this.outerContainerTarget.classList.add('-show');
  }

  closeMobile() {
    this.outerContainerTarget.classList.remove('-show');
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  select(date) {
    this.scrollToTop();
    this.filterEvents(date);
    this.closeMobile();
    this.imageTarget.classList.add('-hide');
    let show = this.eventsContainer.querySelectorAll('[data-date].-show').length === 0;
    document.querySelector('.js-no-events').classList.toggle('-show', show);
    this.viewAllTargets.forEach((viewAll) => {
      viewAll.classList.add('-show');
    });
    let date_formatted = moment(date).format('dddd, MMM. D');
    this.labelTarget.innerHTML = date_formatted.replace(/\,/g, ',<br/>');
  }

  clear() {
    this.viewAllTargets.forEach((viewAll) => {
      viewAll.classList.remove('-show');
    });
    this.closeMobile();
    this.gridGroups.forEach((gridGroup) => {
      gridGroup.classList.add('-show');
    });
    this.imageTarget.classList.remove('-hide');
    document.querySelector('.no_events_title').classList.remove('-show');
    this.eventsContainer.classList.remove('-hide');
    this.labelTarget.innerHTML = 'Select<br /> a Date';
  }

  getEvents() {
    let dates = [];
    this.eventsContainer.querySelectorAll('[data-date]').forEach((dateElem) => {
      dates.push(moment(dateElem.dataset.date).format('ddd MMM DD Y'));
    });
    return dates;
  }

  filterEvents(date) {
    let formattedDate = moment(date).format('YYYY-MM-DD');
    this.eventsContainer.querySelectorAll('[data-date]').forEach((dateElem) => {
      dateElem.classList.toggle('-show', dateElem.dataset.date === formattedDate);
    });
    if (this.eventsContainer.querySelectorAll('[data-date].-show').length === 0) {
      document.querySelector('.no_events_title').classList.add('-show');
      this.eventsContainer.classList.add('-hide');
    }
  }
}
